import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import transformMultilineStop from 'src/app/component/shared/others/multiline-stop';

export interface TimeTableTripEditInput {
  trip;
  routeStops;
}

@Component({
  selector: 'app-timetable-trip-edit',
  templateUrl: './timetable-trip-edit.component.html',
  styleUrls: ['./timetable-trip-edit.component.scss'],
})
export class TimetableTripEditComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<TimetableTripEditComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: TimeTableTripEditInput
  ) {}

  tripData;
  tripStops;

  ngOnInit() {
    const tripCopy = JSON.parse(JSON.stringify(this.dialogData.trip));
    tripCopy.stops.forEach(stop => {
      stop.skip = stop?.skip ?? false;
      stop.stopName =
        this.dialogData.routeStops.find(
          routeStop => routeStop.stopCode === stop.stopId
        )?.stopName ?? '';
      stop.multilineStop = transformMultilineStop(stop.stopName);
    });
    this.tripData = tripCopy;
    // console.log('modal: ', { tripData: this.tripData });
  }

  onEdit() {
    console.log(this.tripData);
    this.dialogRef.close(this.tripData);
  }
}
